import { ICadastrarHistoricoCasoVistoria } from "../../../Interfaces/VistoriaEntregaChaves/AcoesVistoria/AcoesVistoriaInterface";
import {
    CadastrarHistoricoCasoVistoriaService,
    GetHistoricoCasoVistoriaService,
} from "../../../Services/VistoriaEntregaChaves/AcoesVistoria/AcoesVistoriaServices";
import { Controller } from "../../Controller";

export async function GetHistoricoCasoVistoriaController(idCaso: number) {
    return Controller(GetHistoricoCasoVistoriaService(idCaso));
}

export async function CadastrarHistoricoCasoVistoriaController(
    requestBody: ICadastrarHistoricoCasoVistoria
) {
    return Controller(CadastrarHistoricoCasoVistoriaService(requestBody));
}
